import { useSelector } from 'react-redux'
import { object } from 'prop-types'
import {
  APIProvider,
  Map,
} from '@vis.gl/react-google-maps'
import Div from '@ui/layout/Div'
import SterilizationCallMarker from './SterilizationCallMarker'

const SterilizationsMap = ({ dataSterilizationCalls }) => {
  const { calls } = useSelector(state => state.sterilization)
  const { mission } = useSelector(state => state.main)

  const renderMarkers = () => {
    if (calls) {
      return dataSterilizationCalls.nodes.map(call => {
        return <SterilizationCallMarker
          sterilizationCall={call}
          key={`call-marker-${call.id}`}
        />
      })
    }
  }

  return (
    <Div cssClass='sterilization-calls-map'>
      <Map
        style={{ width: '100%', height: '500px' }}
        defaultZoom={12}
        defaultCenter={mission.coordinates}
        fullscreenControl={true}
        gestureHandling="cooperative"
        mapId={`sterilization-calls-${mission.mairie.name}`}
      >
        {renderMarkers()}
      </Map>
    </Div>
  )
}

const SterilizationsListMap = ({ dataSterilizationCalls }) => {
  return (
    <Div cssClass='sterilization-calls-map'>
      <APIProvider apiKey={import.meta.env.VITE_MAPS_KEY} region='fr' language='fr_FR'>
        <SterilizationsMap dataSterilizationCalls={dataSterilizationCalls} />
      </APIProvider>
    </Div>
  )
}

SterilizationsMap.propTypes = {
  dataSterilizationCalls: object
}

SterilizationsListMap.propTypes = {
  dataSterilizationCalls: object
}

export default SterilizationsListMap